<ng-container *transloco="let t; prefix: scope">
  <div class="flex w-full h-screen bg-blg-grey-75 dark:bg-blg-grey-950 overflow-hidden" appDragAndDrop>
    <bl-frontend-nav-menu
      [organizationMenu]="selectCompanyMenu$ | async"
      [menuSections]="(menuSections$ | async) || []"
      [mobileNavMenuState]="mobileMenuState"
      [menuHeader]="menuHeader$ | async"
      (closeMenu)="toggleMenuIfMobile()"
      (menuToggled)="onMenuToggle($event)">
      <div snippet="menuFooter" [innerHTML]="t('menuFeedback') | safeHtml" class="px-4"></div>
    </bl-frontend-nav-menu>
    <div class="h-full flex flex-col flex-1 min-w-0">
      <app-navbar (newNote)="showNewNoteDialog()" (settings)="showSettingsDialog()" (logout)="logout()"></app-navbar>

      <div class="bg-card rounded-3xl shadow p-3 pt-4 h-full overflow-auto">
        <div class="h-full overflow-auto">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</ng-container>
